import React, { Component } from "react";
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Paper from '@material-ui/core/Paper';
import Snackbar from "@material-ui/core/Snackbar";
import { MyContext } from "../../../MyProvider";
import { getUsers } from "../../general_functions/employeeFunctions";
import AddUser from "./addUser";
import AllUsers from "./allUsers";
import UpdateUser from "./updateUser";
// import Header from "../../header/Header";

import "../../../styles/css/main.css";
import "../../../styles/css/cpanel.css";

export default class EmployeeMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      snackbarText: "",
      openSnackbar: false,
      users: []
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  componentWillMount() {
    getUsers(res => {
      this.setState({ users: res.user });
    });
  }

  handleSnackbar = (text) => {
    this.setState({ openSnackbar: true, snackbarText: text });
  }

  render() {
    let { value, users } = this.state;
    return (
      <MyContext.Consumer>
        {context => {
          console.log(context)
          return (
            <div className={"page-controler"}>
              {/* <Header context={context.state} /> */}
              <div className={"wrapper"}>
                <Paper>
                  <Tabs
                    value={value}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="Create new user"/>
                    <Tab label="Update user" />
                    <Tab label="All user" />
                  </Tabs>
                </Paper>

                {value === 0 &&
                  <AddUser
                    handleSnackbar={this.handleSnackbar}
                    context={context}/>}
                {value === 1 &&
                  <UpdateUser
                  users={users}
                    handleSnackbar={this.handleSnackbar}
                    context={context}/>}
                {value === 2 &&
                  <AllUsers
                    users={users}
                    handleSnackbar={this.handleSnackbar}
                    context={context}/>}

                <Snackbar
                  open={this.state.openSnackbar}
                  message={this.state.snackbarText}
                  autoHideDuration={4000}
                  onRequestClose={() => this.setState({ openSnackbar: false })}
                />
              </div>
            </div>
          );
        }}
      </MyContext.Consumer>
    );
  }
}

const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400
  }
};
